import React, {MutableRefObject, useCallback} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {FileInputProps, HandleFileChangeProps} from './types'

export const handleFileClick = (fileInputRef: MutableRefObject<HTMLInputElement | null>) => {
    if (fileInputRef.current) {
        fileInputRef.current.click()
    }
}


const FileInput: React.FC<FileInputProps> = React.memo(
    ({
         fileInputRef,
         filesCount,
         setFilesCount,
         formik,
         description,
         accept,
         multiple = false,
         name,
     }) => {

        const handleFileChange = useCallback(
            ({e, formik, setFilesCount}: HandleFileChangeProps) => {
                const files = Array.from(e.target.files || []) as File[]

                if (multiple) {
                    if (files.length > 0) {
                        formik.setFieldValue(name, files)
                        setFilesCount(files.length)
                    } else {
                        formik.setFieldValue(name, [])
                    }
                } else {

                    if (files.length > 0) {
                        setFilesCount(files.length)
                        formik.setFieldValue(name, files[0])
                    } else {
                        formik.setFieldValue(name, [])
                    }
                }
            },
            [multiple, name],
        )


        return (
            <div className="d-flex flex-column fv-row fv-plugins-icon-container">
                <div className="fv-row">
                    <label className="fs-6 fw-semibold mb-2">Pièce(s) jointe(s)</label>

                    <div
                        className="btn btn-outline btn-outline-dashed btn-outline-default d-flex justify-content-between text-start p-6 active"
                        onClick={() => handleFileClick(fileInputRef)}
                    >
                        <div className="d-flex">
                            <KTSVG path={toAbsoluteUrl('/media/svg/files/upload.svg')}
                                   className="svg-icon svg-icon-3hx" />
                            <div className="ms-4">
                                <span className="fs-5 fw-bolder text-gray-900 mb-2 d-block">Ajouter des fichiers</span>
                                <span className="fw-bold fs-7 text-muted d-block">{description}</span>
                            </div>
                        </div>
                        <span className="fw-bold fs-6 text-gray-900 d-block">
                            {filesCount > 0 ? `${filesCount} fichiers` : 'Aucun fichier choisi'}
                        </span>
                    </div>
                    <div>
                        <input
                            type="file"
                            ref={fileInputRef}
                            accept={accept}
                            multiple={multiple}
                            onChange={(e) => handleFileChange({e, formik, setFilesCount})}
                            style={{display: 'none'}}
                        />
                        {formik.touched[name] && formik.errors[name] && (
                            <div
                                className="fv-plugins-message-container my-1">
                                <div className="fv-help-block">
                                    <span role="alert" className="text-danger p-2">{formik.errors[name]}</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    },
)

export {FileInput}
